<template>
  <div class="page-section" style="padding-top: 20px;">
    <h1 class="info-title">Got some spare cash <b>doing nothing?</b></h1>

    <div class="section-subtitle">
      <b>
        Based on your income and expenses from the last 6 months, you have an average of
        <b> £{{ numberToHumanReadable(spareCash) }}/month sitting idle.</b>
        <br>
        <br>
        Why not put it to work?
      </b>
    </div>

    <button class="light-blue-button" @click="handleButtonClick">
      Explore saving options <span class="arrow-right">→</span>
      </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { numberToHumanReadable } from '../../../../utils/miscUtils';

const props = defineProps({
  monthlyAvgDisposableIncome: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['buttonClick']);
const spareCash = computed(() => props.monthlyAvgDisposableIncome.total);

const handleButtonClick = () => {
  emit('buttonClick');
};

</script>

<style lang="scss" scoped>
@import "../../../../scss/riseup-vars";

.page-section {
  background-color: #205441;
  color: #202125;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 45px;
}

.info-title {
  font-size: 34px;
  color: #FFFFFF;
  padding-top: 15px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.info-title b {
  font-weight: 900 !important;
}

.section-subtitle {
  font-size: 17px;
  margin-top: 25px;
  margin-bottom: 40px;
  color: #FFFFFF;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.light-blue-button {
  background: #5D7AFD;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  color: white;
  padding: 17px 0px;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
  padding-bottom: 18px;
  width: 80%;
}
</style>
